import { render, staticRenderFns } from "./MailQueues.vue?vue&type=template&id=2ed9c2f3&"
import script from "./MailQueues.vue?vue&type=script&lang=js&"
export * from "./MailQueues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports